import { render, staticRenderFns } from "./MlbTourStages.vue?vue&type=template&id=74805026&scoped=true&"
import script from "./MlbTourStages.vue?vue&type=script&lang=js&"
export * from "./MlbTourStages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74805026",
  null
  
)

export default component.exports